import {createStore,combineReducers} from 'redux'
import ProductReducer from './Reducers/ProductReducer'
import { devToolsEnhancer } from 'redux-devtools-extension'
import CartReducer from './Reducers/CartReducer'
const root = combineReducers({
    ProductReducer,
    CartReducer
});
const store = createStore(root, devToolsEnhancer())
export default store;